const { Badge } = require("antd")

const WorkinStatus = ({ value }) => {
    switch (value) {
        case "Normal":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)
        case "ปกติ":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)

        case "Absent":
            return (<Badge color="#F15046" text={value} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", color: "#F15046" }} />)
        case "ขาดงาน":
            return (<Badge color="#F15046" text={value} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", color: "#F15046" }} />)

        case "Late":
            return (<Badge color="#FFBF1A" text={value} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", color: "#FFBF1A" }} />)
        case "เข้างานสาย":
            return (<Badge color="#FFBF1A" text={value} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", color: "#FFBF1A" }} />)

        case "ลางาน":
            return (<Badge color="#F1620F" text={value} style={{ backgroundColor: "#FFF5EA", borderRadius: "16px", padding: "2px 8px", color: "#F1620F" }} />)
        case "Leave":
            return (<Badge color="#F1620F" text={value} style={{ backgroundColor: "#FFF5EA", borderRadius: "16px", padding: "2px 8px", color: "#F1620F" }} />)

        case "Early":
            return (<Badge color="#6A51C1" text={value} style={{ backgroundColor: "#E1DCF3", borderRadius: "16px", padding: "2px 8px", color: "#6A51C1" }} />)
        case "ออกงานก่อนเวลา":
            return (<Badge color="#6A51C1" text={value} style={{ backgroundColor: "#E1DCF3", borderRadius: "16px", padding: "2px 8px", color: "#6A51C1" }} />)

        case "วันหยุด":
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
        case "Holiday":
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)

        case "หยุดตามกะการทำงาน":
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
        case "Day Off":
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
        case "คำขอรับรองเวลา":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)
        case "Endorse Time":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)
        case "ทำงานล่วงเวลา":
            return (
                <Badge
                    color="#9E77ED"
                    text={value}
                    style={{
                        backgroundColor: "#F4EBFF",
                        borderRadius: "16px",
                        padding: "2px 8px",
                        color: "#6941C6"
                    }}
                />
            );
        case "Overtime":
            return (
                <Badge
                    color="#9E77ED"
                    text={value}
                    style={{
                        backgroundColor: "#F4EBFF",
                        borderRadius: "16px",
                        padding: "2px 8px",
                        color: "#6941C6"
                    }}
                />
            );

        default:
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
    }
}

export default WorkinStatus;